<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="640"
        :fullscreen="isMobile" persistent scrollable @keydown.esc="chiudi">
        <v-card>
            <v-card-title>{{ form.id ? 'Modifica dispositivo' : 'Nuovo dispositivo' }}</v-card-title>
            <v-card-text>
                <v-form ref="formRef">
                    <v-text-field v-model="form.nome" label="Nome (es. Cassetta Reparto 1, Estintore ingresso)"
                        :rules="[v => !!v || 'Campo obbligatorio']" class="mb-4" />
                    <v-select v-model="form.tipoDispositivoSicurezzaId" :items="tipi" item-title="nome" item-value="id"
                        label="Tipo" :rules="[v => !!v || 'Campo obbligatorio']" class="mb-4" />

                    <div class="text-caption text-medium-emphasis mb-2">Ubicazione (facoltativa)</div>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-select v-model="form.repartoId" :items="reparti" item-title="nome" item-value="id"
                                label="Reparto" clearable />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select v-model="form.mezzoId" :items="mezzi" item-title="nome" item-value="id"
                                label="Mezzo" clearable :disabled="!!mezzoFisso" />
                        </v-col>
                    </v-row>
                    <v-text-field v-model="form.sedeNome" label="Sede (se non censita come reparto/mezzo)"
                        class="mb-4" />

                    <v-text-field v-model="form.dataAcquisto" type="date" label="Data acquisto (facoltativa)"
                        class="mb-4" />
                    <v-textarea v-model="form.note" label="Note" rows="2" />
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="chiudi">Annulla</v-btn>
                <v-btn color="primary" :loading="salvataggio" @click="salva">Salva</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DialogDispositivoSicurezza",

    props: {
        modelValue: { type: Boolean, default: false },
        dispositivo: { type: Object, default: null },
        // Se valorizzato (es. aperto da MezzoDettaglio.vue), precompila e blocca il
        // campo Mezzo: l'utente è già nel contesto di quel mezzo specifico.
        mezzoFisso: { type: [Number, String], default: null },
    },
    emits: ["update:modelValue", "salvato"],

    data() {
        return {
            form: this.formVuoto(),
            salvataggio: false,
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.display.smAndDown;
        },
        tipi() {
            return this.$store.getters["tipiDispositivoSicurezza/lista"];
        },
        reparti() {
            return this.$store.getters["configurazione/reparti"];
        },
        mezzi() {
            return this.$store.getters["mezzi/lista"];
        },
    },

    watch: {
        modelValue(val) {
            if (val) {
                this.inizializza();
                this.$store.dispatch("tipiDispositivoSicurezza/carica");
                this.$store.dispatch("configurazione/caricaReparti");
                this.$store.dispatch("mezzi/carica");
            }
        },
    },

    methods: {
        formVuoto() {
            return {
                id: null,
                nome: "",
                tipoDispositivoSicurezzaId: null,
                repartoId: null,
                mezzoId: null,
                sedeNome: "",
                dataAcquisto: "",
                note: "",
            };
        },

        inizializza() {
            this.form = this.dispositivo
                ? {
                    id: this.dispositivo.id,
                    nome: this.dispositivo.nome,
                    tipoDispositivoSicurezzaId: this.dispositivo.tipoDispositivoSicurezzaId,
                    repartoId: this.dispositivo.repartoId,
                    mezzoId: this.dispositivo.mezzoId,
                    sedeNome: this.dispositivo.sedeNome,
                    dataAcquisto: this.dispositivo.dataAcquisto ? this.dispositivo.dataAcquisto.substr(0, 10) : "",
                    note: this.dispositivo.note,
                }
                : { ...this.formVuoto(), mezzoId: this.mezzoFisso || null };
        },

        async salva() {
            if (!this.$refs.formRef.validate()) return;

            this.salvataggio = true;
            try {
                const { id, ...dati } = this.form;
                dati.dataAcquisto = dati.dataAcquisto || null;
                await this.$store.dispatch("dispositiviSicurezza/salva", { id, dati });
                this.$emit("salvato");
                this.chiudi();
            } catch (error) {
                console.log(error);
            }
            this.salvataggio = false;
        },

        chiudi() {
            this.$emit("update:modelValue", false);
        },
    },
};
</script>
